import React, { useState } from "react";

import {
  MapMarker,
  MapMarkerDisplayTypeEnum,
} from "@/custom-types/StoreLocator";

import { MarkerIcon } from "./MarkerShapes";

const IMAGE_ENABLED_DISPLAY_TYPES = [
  MapMarkerDisplayTypeEnum.ProminentImageContainer,
  MapMarkerDisplayTypeEnum.ImageContainer,
];

const DPR_SUPPORT = [1, 2, 3];

type MapMarkerImageProps = {
  alt: string;
  mapMarker: MapMarker;
  onImageLoad?: (loaded: boolean) => void;
};

const MapMarkerImage = ({
  alt,
  mapMarker,
  onImageLoad,
}: MapMarkerImageProps) => {
  const [imageError, setImageError] = useState(false);
  const { displayType, locationType, imageUrl } = mapMarker;

  if (!IMAGE_ENABLED_DISPLAY_TYPES.includes(displayType)) {
    return null;
  }

  // show fallback icon if imageUrl is null or invalid
  if (!imageUrl || imageError) {
    return (
      <MarkerIcon
        aria-label={alt}
        className="absolute scale-[.65]"
        href={`#marker-icon-${locationType || "storefront"}`}
      />
    );
  }

  const imgSize =
    displayType === MapMarkerDisplayTypeEnum.ProminentImageContainer ? 60 : 44;
  const src = `${imageUrl}?auto=compress,format&w=${imgSize}`;
  const srcSet = DPR_SUPPORT.map((dpr) => `${src}&dpr=${dpr} ${dpr}x`).join(
    ",",
  );

  return (
    <img
      src={src}
      srcSet={srcSet}
      alt={alt}
      className="map-marker__image absolute rounded-full bg-white lazyload"
      onLoad={() => onImageLoad?.(true)}
      onError={() => setImageError(true)}
    />
  );
};

export default MapMarkerImage;
